import ProfileTemplate from '../../templates/Profile';
import {compose} from 'redux';
import {connect} from 'react-redux';
import * as Actions from '../../modules/User/actions';

const mapStateToProps = state => {
  return state
};

const mapDispatchToProps = dispatch => {
  return {
      updateUserProfile(newState) {
          dispatch(Actions.updateUserProfile(newState))
      }
  }
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ProfileTemplate);